export default function handleSelectOnFocus(
  e: React.FocusEvent<HTMLInputElement>
) {
  e.target.select();
}
